import { render } from "./AccountSelector.vue?vue&type=template&id=fa64ac3a&scoped=true"
import script from "./AccountSelector.vue?vue&type=script&lang=js"
export * from "./AccountSelector.vue?vue&type=script&lang=js"

import "./AccountSelector.vue?vue&type=style&index=0&id=fa64ac3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa64ac3a"]])

export default __exports__